import { ErrorRounded as ErrorIcon } from '@mui/icons-material';

// 用于MUI TextField的helperText错误提示
export function InputError({ message }: any) {
  return (
    <span style={{ color: 'error.main', fontSize: '1rem', display: 'flex', alignItems: 'baseline' }}>
      <ErrorIcon sx={{ mr: 0.5, fontSize: '1rem', position: 'relative', top: '2px' }} /> 
      <span>{message}</span>
    </span>
  );
}

export function createInputError(message: any) {
  return (
    <InputError message={message} />
  );
}
